import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import {
  activeProcessSF,
  getActiveProcessKey,
  handleProcess,
  IRydeProcess,
  RydeProcessTitle,
  RydeUiUnit,
  TAddressedFieldsValueOnCompleted,
  useProcesses,
} from "@ryde/shared";

export const useWatchBulkRideRecalculateSupplierPrice = ({
  entity,
  addressedFieldsValueOnCompleted,
}: {
  entity: RydeUiUnit;
  addressedFieldsValueOnCompleted: TAddressedFieldsValueOnCompleted;
}) => {
  const bulkRecalculateSupplierPriceProcessKey = getActiveProcessKey(
    RydeProcessTitle.BulkRecalculateSupplierPrice,
    entity,
  );

  const bulkRecalculateSupplierPriceProcess = useRecoilValue(
    activeProcessSF(bulkRecalculateSupplierPriceProcessKey),
  );
  const { stopProcessPolling } = useProcesses();
  const { t } = useTranslation();

  const onComplete = useCallback(
    (process: IRydeProcess) => {
      addressedFieldsValueOnCompleted(process);
    },
    [addressedFieldsValueOnCompleted],
  );

  useEffect(() => {
    handleProcess({
      entity,
      processTitle: RydeProcessTitle.BulkRecalculateSupplierPrice,
      toastSummaryOnComplete: true,
      process: bulkRecalculateSupplierPriceProcess,
      onComplete,
      translationFunction: t,
      stopProcessPolling,
    });
  }, [
    bulkRecalculateSupplierPriceProcess,
    entity,
    onComplete,
    stopProcessPolling,
    t,
  ]);
};
